const badge = {
  styleOverrides: {
    root: {
      '& .MuiBadge-dot': {
        height: 12,
        minWidth: 12,
        borderRadius: 6
      }
    }
  }
};

export default badge;
